import axiosNew from '../../../helpers/axios'
import { cleanObject, cleanObjectNull } from '../../../helpers/queryBuilder'

export const getAllTaskLogList = async (
    data
) => {
    const { page,
        limit,
        start,
        end,
        projectId,
        userId, } = data

    return new Promise(async (resolve) => {
        const skip = page && limit ? (page - 1) * limit : 0

        const rawBody = {
            skip,
            limit,
            start,
            end,
            projectId,
            userId,
        }

        const body = cleanObject(rawBody)
        try {
            const res = await axiosNew({
                url: 'reports/user-timelog-list',
                method: 'POST',
                data: body,
            })
            resolve({ data: res.data ?? {} })
        } catch (error) {
            console.log(error, "error=====");

            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

export const getUserLogByID = async ({
    page,
    limit,
    start,
    end,
    projectId,
    userId,
}) => {
    return new Promise(async (resolve) => {
        const skip = page && limit ? (page - 1) * limit : 0

        const rawBody = {
            // skip,
            // limit,
            start,
            end,
            projectId,
            userId,
        }
        const body = cleanObject(rawBody)

        try {
            const res = await axiosNew({
                url: 'reports/project-timelog',
                method: 'POST',
                data: body,
            })
            resolve({ data: res.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

export const projectByUserId = async ({
    page,
    limit,
    userId,
}) => {
    const skip = page && limit ? (page - 1) * limit : 0;

    const params = {
        userId,
        skip,
        limit,
    };

    try {
        const res = await axiosNew.get('users/project-list', { params });
        return { data: res.data ?? {} };
    } catch (error) {
        return { data: error?.response?.data ?? {} };
    }
};